/* eslint-disable implicit-arrow-linebreak */
import { useNamespace, useOkapiKy } from '@folio/stripes-core';
import { useQuery } from 'react-query';

function useRecordLocks() {
  const okapiKy = useOkapiKy();
  const [namespace] = useNamespace({ key: 'recordLocksConfigs' });

  const {
    isLoading,
    isError,
    data = {},
    refetch,
    isFetched,
    ...rest
  } = useQuery(
    [namespace],
    async () => {
      const result = await okapiKy
        .get('inventory-templates-configs?query=(configCode==recordlocks)')
        .json();
      return result;
    },
    {
      enabled: true,
      // No automatic refetch - we refetch manually after changes
      refetchInterval: false,
      // Reduced caching for more up-to-date lock data
      cacheTime: 30000, // 30 seconds (reduced from 5 minutes)
      staleTime: 5000, // 5 seconds (reduced from 1 minute)
    },
  );

  const result = {
    isLoading,
    isFetched,
    isError,
    refetch,
    recordLocks: !isLoading ? data?.templatesConfigs[0]?.configValue || {} : {},
    configId: !isLoading ? data?.templatesConfigs[0]?.id : undefined,
    rest,
  };

  return result;
}

export default useRecordLocks;
